import { DefaultAdapter } from './adapters/default-adapter';
import { TableAdapter } from './adapters/table-adapter';
import { ChatResponse } from './chat-response.model';

export class ResponseAdapterFactory {
  static getAdapter(function_name: string): ChatResponse {
    const adapters: Record<string, ChatResponse> = {
      table: new TableAdapter(),
    };

    return adapters[function_name] || new DefaultAdapter();
  }
}
